import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "history-body__summary" }
const _hoisted_2 = { class: "history-body__summary-header" }
const _hoisted_3 = { class: "caption-large--bold color-grey-light" }
const _hoisted_4 = { class: "arrow-box color-grey-light" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "history-body__summary-header_tabs" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "caption-navbar color-grey-light" }
const _hoisted_9 = { class: "history-body__summary-sum" }
const _hoisted_10 = { class: "h1" }

import HistoryChart from "@/components/history/HistoryChart.vue";
import HistoryOperationsList from "@/components/history/HistoryOperationsList.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import { useHistoryOperations } from "@/composables/history/useHistoryOperations";

export default /*@__PURE__*/_defineComponent({
  __name: 'HistoryOperations',
  setup(__props) {

const {
  activeTab,
  choosePeriod,
  filteredOperations,
  getOperationIcon,
  getOperationIconAlt,
  getOperationMeta,
  getOperationSubtitle,
  getOperationTitle,
  getOperationValue,
  isCustomPeriod,
  isOpenedSelect,
  openSelect,
  operationsTabs,
  periodOptions,
  periodText,
  resetPeriod,
  selectTab,
  selectedPeriod,
  totalSum,
  totalUnit,
} = useHistoryOperations();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "history-body__summary-header_period",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(openSelect) && _unref(openSelect)(...args)), ["stop"]))
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(periodText)), 1),
          _createElementVNode("div", _hoisted_4, [
            (_unref(isCustomPeriod))
              ? (_openBlock(), _createBlock(BaseIcon, {
                  key: 0,
                  name: "close",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(resetPeriod)()), ["stop"]))
                }))
              : (_openBlock(), _createBlock(BaseIcon, {
                  key: 1,
                  name: "service-arrow",
                  position: _unref(isOpenedSelect) ? 'top' : 'bottom',
                  onClick: _withModifiers(_unref(openSelect), ["stop"])
                }, null, 8, ["position", "onClick"]))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["period-select", { open: _unref(isOpenedSelect) }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(periodOptions), (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.value,
                class: "period-select__item",
                onClick: _withModifiers(($event: any) => (_unref(choosePeriod)(option.value)), ["stop"])
              }, _toDisplayString(option.label), 9, _hoisted_5))
            }), 128))
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operationsTabs), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["history-body__summary-header_tabs-item", { active: item.active }]),
              onClick: ($event: any) => (_unref(selectTab)(item.key))
            }, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(item.title), 1)
            ], 10, _hoisted_7))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(totalSum)) + " " + _toDisplayString(_unref(totalUnit)), 1)
      ]),
      _createVNode(HistoryChart, {
        period: _unref(selectedPeriod),
        operations: _unref(filteredOperations),
        "active-tab": _unref(activeTab)
      }, null, 8, ["period", "operations", "active-tab"])
    ]),
    _createVNode(HistoryOperationsList, {
      operations: _unref(filteredOperations),
      "get-operation-icon": _unref(getOperationIcon),
      "get-operation-icon-alt": _unref(getOperationIconAlt),
      "get-operation-title": _unref(getOperationTitle),
      "get-operation-subtitle": _unref(getOperationSubtitle),
      "get-operation-value": _unref(getOperationValue),
      "get-operation-meta": _unref(getOperationMeta)
    }, null, 8, ["operations", "get-operation-icon", "get-operation-icon-alt", "get-operation-title", "get-operation-subtitle", "get-operation-value", "get-operation-meta"])
  ], 64))
}
}

})